import { RelatorioContaPagarModel } from "@/models/contabil/contas-pagar/RelatorioContaPagarModel";
import { integracaoContabilApi } from "@/api/IntegracaoContabilApi";
import { ContaPagarValidacaoContabilModel } from "@/models/contabil/contas-pagar/ContaPagarValidacaoContabilModel";

export default class ContabilContaPagarService {
  static gerarRelatorio(relatorio: RelatorioContaPagarModel): Promise<any> {
    const requestRelatorioContaPagarDTO = {
      inicio: relatorio.inicio,
      fim: relatorio.fim,
      tipoNaturezaServico: relatorio.naturezaServico?.valor,
    };

    return integracaoContabilApi.gerarRelatorioContasPagar(
      requestRelatorioContaPagarDTO
    );
  }

  static gerarRelatorioExcel(relatorio: RelatorioContaPagarModel): Promise<any> {
    const requestRelatorioContaPagarDTO = {
      inicio: relatorio.inicio,
      fim: relatorio.fim,
      tipoNaturezaServico: relatorio.naturezaServico?.valor,
    };

    return integracaoContabilApi.gerarRelatorioContasPagarExcel(
      requestRelatorioContaPagarDTO
    );
  }

  static gerarPagamentos(idsSelecionado: number[]): Promise<any> {
    return integracaoContabilApi.gerarPagamentos(idsSelecionado);
  }

  static listarContasPagar(): Promise<ContaPagarValidacaoContabilModel[]> {
    return integracaoContabilApi.listarContasPagar();
  }

  static filtrar(filtro: any): Promise<any> {
    const filtroDTO = {
      inicio: filtro.inicio,
      fim: filtro.fim,
      status: filtro?.status?.name,
    };

    return integracaoContabilApi.filtrarValidacaoContabil(filtroDTO);
  }

  static filtrarContasPagarPorStatusAprovadaEEnviadaPagamento(
    filtro: any
  ): Promise<any> {
    const dto = {
      status: filtro.name,
    };

    return integracaoContabilApi.filtrarContasPagarPorStatusAprovadaEEnviadaPagamento(dto);
  }

  static filtrarContasPagarPorStatus(filtro: any): Promise<any> {
    const dto = {
      status: filtro.name,
    };
    return integracaoContabilApi.filtrarContasPagarPorStatus(dto);
  }

  static atualizarStatusParaAprovada(idContaPagar: number): Promise<any> {
    return integracaoContabilApi.atualizarStatusParaAprovada(idContaPagar);
  }

  static atualizarStatusParaReprovada(idContaPagar: number, refuseReason: string): Promise<any> {
    return integracaoContabilApi.atualizarStatusParaReprovada(idContaPagar, refuseReason);
  }

  static atualizarStatusNFParaAprovadaSaude(notaFiscal: string, ): Promise<any> {
    return integracaoContabilApi.atualizarStatusNFParaAprovadaSaude(notaFiscal );
  }
  
  static atualizarStatusNFParaAprovadaAssitencia(notaFiscal: string, ): Promise<any> {
    return integracaoContabilApi.atualizarStatusNFParaAprovadaAssintencia(notaFiscal);
  }

  static atualizarStatusNFParaReprovadaSaude(notaFiscal: string, motivoRecusa:string): Promise<any> {
    return integracaoContabilApi.atualizarStatusNFParaReprovadaSaude(notaFiscal, motivoRecusa);
  }

  static atualizarStatusNFParaReprovadaAssintencia(notaFiscal: string, motivoRecusa:string): Promise<any> {
    return integracaoContabilApi.atualizarStatusNFParaReprovadaAssistencia(notaFiscal, motivoRecusa);
  }

  static downloadNotaFiscal(nomeArquivo: string): Promise<any> {
    return integracaoContabilApi.downloadNotaFiscal(nomeArquivo);
  }

  static downloadPedagio(idContaPagar: number): Promise<any> {
    return integracaoContabilApi.downloadPedagio(idContaPagar);
  }

  static listarContaPagarStatusAprovada(): Promise<any> {
    return integracaoContabilApi.listarContaPagarStatusAprovada("APROVADA" );
  }
}
